// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"QrCode_pageHolder__34R0-","ListHolder":"QrCode_ListHolder__37uEV"};